import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LogoutService {
  private readonly httpClient = inject(HttpClient);

  logOut(refreshToken: string): Observable<void> {
    const url = 'api/v1/logout';

    return this.httpClient.post<void>(environment.portalApiUrl + url, {
      refreshToken,
    });
  }
}
